var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-basic-info"},[_c('gc-group-detail',{attrs:{"data":_vm.deviceBasicInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }